import React, { PropsWithChildren } from 'react';
import { PageWithHeader } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { PageNotice } from '../../PageNotice';

/**
 * The header of the TechDocs page, named the way the sidebar names it. The
 * subtitle is the one the plugin gives its own.
 *
 * @public
 */
export const TechDocsPageWrapper = (props: PropsWithChildren<{}>) => {
  const configApi = useApi(configApiRef);
  const orgName =
    configApi.getOptionalString('organization.name') ?? 'Backstage';
  return (
    <PageWithHeader
      title="Docs"
      subtitle={`Documentation available in ${orgName}`}
      themeId="documentation"
    >
      {props.children}
    </PageWithHeader>
  );
};

/**
 * What the TechDocs page shows above the list: where the documentation comes
 * from, the same kind of note as on the Organization page and in the same
 * place.
 *
 * It stands in for the header row the plugin puts there, which holds nothing
 * but a support button - and with no support configured for the app, that
 * only lists Backstage's own links.
 *
 * @public
 */
export const TechDocsContentHeader = () => (
  <PageNotice>
    The documentation listed below is written in Markdown and kept in GitLab
    repositories. It is built from there and shows what the repositories hold.
  </PageNotice>
);
